import { PropsWithChildren } from 'react'
import Styles from './ToastMessage.module.scss'
import cx from 'classnames'
import { MessageVariant } from './Root'
export const Icon = ({ children, variant = 'success' }: PropsWithChildren<{ variant?: MessageVariant }>) => (
  <div className={cx(Styles.icon, Styles[variant])}>{children}</div>
)
